<template>
  <b-row>
    <b-col>
      <span>{{ video.description }}</span>
      <br />
      <b-row class="mt-2">
        <b-col v-if="video.tipps || video.variants || (video.counter && video.counterUnit)" class="text-left">
          <a 
            v-if="video.counter && video.counterUnit"
            class="mr-4"
          >
            <i class="icon fa fa-clock-o text-green mr-1" aria-hidden="true" />{{$t("ELEMENT_VideoDescription_counter_unit_" + video.counterUnit, { counter: video.counter })}}

          </a>
          <a
            v-if="video.tipps"
            class="mr-4"
            href
            @click.stop.prevent="() => $emit('openTipps')"
            >{{ $t('PAGE_playlist_tipps') }}</a
          >
          <a
            v-if="video.variants"
            href
            @click.stop.prevent="() => $emit('openVariants')"
            >{{ $t('PAGE_playlist_variants') }}</a
          >
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'VideoDescription',
  props: ['video'],
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/elements/VideoDescription.vue